import React, { memo, forwardRef } from "react";
const SvgCeiling = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect width={10} height={14} x={11} y={7} fill="#DBDBDB" rx={2} />
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M4 25a1 1 0 001 1h8a1 1 0 100-2H6v-8a1 1 0 10-2 0v9zM28 25a1 1 0 01-1 1h-8a1 1 0 110-2h7v-8a1 1 0 112 0v9z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgCeiling.displayName = "SvgCeiling";
const MemoForwardRef = memo(SvgCeiling);
export default MemoForwardRef;
